function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["allowDuplicateCitations"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CitationsContext = /*#__PURE__*/createContext();
export var CitationsProvider = function CitationsProvider(_ref) {
  var children = _ref.children,
    _ref$allowDuplicateCi = _ref.allowDuplicateCitations,
    allowDuplicateCitations = _ref$allowDuplicateCi === void 0 ? false : _ref$allowDuplicateCi;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    citations = _useState2[0],
    setCitations = _useState2[1];
  var addCitation = useCallback(function (citation) {
    setCitations(function (prev) {
      var foundIndex = prev.findIndex(function (c) {
        return c._id === citation._id || !allowDuplicateCitations && c.href === citation.href;
      });
      if (foundIndex >= 0) {
        return [].concat(_toConsumableArray(prev.slice(0, foundIndex)), [citation], _toConsumableArray(prev.slice(foundIndex + 1)));
      }
      return [].concat(_toConsumableArray(prev), [citation]);
    });
  }, [allowDuplicateCitations]);
  var removeCitation = useCallback(function (id) {
    setCitations(function (prev) {
      return prev.filter(function (c) {
        return c._id !== id;
      });
    });
  }, []);
  var getCitationNumber = useCallback(function (citation) {
    return citations.findIndex(function (c) {
      return c._id === citation._id || !allowDuplicateCitations && c.href === citation.href;
    }) + 1;
  }, [citations, allowDuplicateCitations]);
  var value = useMemo(function () {
    return {
      citations: citations,
      addCitation: addCitation,
      removeCitation: removeCitation,
      getCitationNumber: getCitationNumber
    };
  }, [citations, addCitation, removeCitation, getCitationNumber]);
  return /*#__PURE__*/_jsx(CitationsContext.Provider, {
    value: value,
    children: children
  });
};
export var useCitations = function useCitations() {
  return useContext(CitationsContext);
};

/**
 * @template P
 * @param {(props: P) => React.JSX.Element} Component
 * @returns {(props: P) => React.JSX.Element}
 */
export var withCitations = function withCitations(Component) {
  var ComponentWithCitations = function ComponentWithCitations(_ref2) {
    var allowDuplicateCitations = _ref2.allowDuplicateCitations,
      props = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/_jsx(CitationsProvider, {
      allowDuplicateCitations: allowDuplicateCitations,
      children: /*#__PURE__*/_jsx(Component, _objectSpread({}, props))
    });
  };
  ComponentWithCitations.displayName = Component.displayName || 'ComponentWithCitations';
  return ComponentWithCitations;
};